if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        // Start - TSS-003 Customization for Product Media Gallery
        const customNextBtn = this.querySelector('.product-gallery__custom-next-btn');
        const customPrevBtn = this.querySelector('.product-gallery__custom-prev-btn');
        
        if (customNextBtn) {
          customNextBtn.addEventListener('click', this.handleCustomNext.bind(this));
        }
        
        if (customPrevBtn) {
          customPrevBtn.addEventListener('click', this.handleCustomPrev.bind(this));
        }
        
        // Watch for changes to native button states
        this.observeNativeButtons();
        
        // Initialize button states
        setTimeout(() => this.updateCustomNavigationButtons(), 100);
        // End - TSS-003 Customization for Product Media Gallery
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        // Start - TSS-003 Customization for Product Media Gallery
        const mediaId = event.detail.currentElement.dataset.mediaId;
        
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        event.detail.currentElement.classList.add('is-active');
        // End - TSS-003 Customization for Product Media Gallery

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
        
        // Start - TSS-003 Customization for Product Media Gallery
        this.updateCustomNavigationButtons();
        // End - TSS-003 Customization for Product Media Gallery
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        
        // Start - TSS-003 Customization for Product Media Gallery
        setTimeout(() => this.updateCustomNavigationButtons(), 100);
        // End - TSS-003 Customization for Product Media Gallery
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      // Start - TSS-003 Customization for Product Media Gallery
      observeNativeButtons() {
        const nextButton = this.elements.viewer.querySelector('button[name="next"]');
        const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
        
        if (!nextButton || !prevButton) return;
        
        // Create a MutationObserver to watch for disabled attribute changes
        const observer = new MutationObserver(() => {
          this.updateCustomNavigationButtons();
        });
        
        // Observe both buttons for attribute changes
        observer.observe(nextButton, { attributes: true, attributeFilter: ['disabled'] });
        observer.observe(prevButton, { attributes: true, attributeFilter: ['disabled'] });
      }

      handleCustomNext() {
        // Trigger the next button click on the slider component
        const nextButton = this.elements.viewer.querySelector('button[name="next"]');
        if (nextButton && !nextButton.hasAttribute('disabled')) {
          nextButton.click();
        }
      }

      handleCustomPrev() {
        // Trigger the previous button click on the slider component
        const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
        if (prevButton && !prevButton.hasAttribute('disabled')) {
          prevButton.click();
        }
      }

      hideNavigationButtonsForSingleSlide() {
        // Check if there's only one slide in the gallery
        if (!this.elements.viewer) return false;
        
        const mediaItems = this.elements.viewer.querySelectorAll('li[data-media-id]');
        const hasOnlyOneSlide = mediaItems.length <= 1;
        
        if (hasOnlyOneSlide) {
          const customNextBtn = this.querySelector('.product-gallery__custom-next-btn');
          const customPrevBtn = this.querySelector('.product-gallery__custom-prev-btn');
          
          if (customNextBtn) {
            customNextBtn.style.opacity = '0';
            customNextBtn.style.pointerEvents = 'none';
            customNextBtn.style.display = 'none';
          }
          
          if (customPrevBtn) {
            customPrevBtn.style.opacity = '0';
            customPrevBtn.style.pointerEvents = 'none';
            customPrevBtn.style.display = 'none';
          }
        }
        
        return hasOnlyOneSlide;
      }

      updateCustomNavigationButtons() {
        if (this.hideNavigationButtonsForSingleSlide()) {
          return;
        }
        
        const customNextBtn = this.querySelector('.product-gallery__custom-next-btn');
        const customPrevBtn = this.querySelector('.product-gallery__custom-prev-btn');
        
        // Safety check for viewer
        if (!this.elements.viewer) return;
        
        const nextButton = this.elements.viewer.querySelector('button[name="next"]');
        const prevButton = this.elements.viewer.querySelector('button[name="previous"]');
        
        // Update next button visibility
        if (customNextBtn && nextButton) {
          if (nextButton.hasAttribute('disabled')) {
            // Hide next button on last slide
            customNextBtn.style.opacity = '0';
            customNextBtn.style.pointerEvents = 'none';
          } else {
            customNextBtn.style.opacity = '1';
            customNextBtn.style.pointerEvents = 'auto';
          }
        }
        
        // Update previous button visibility
        if (customPrevBtn && prevButton) {
          if (prevButton.hasAttribute('disabled')) {
            // Hide previous button on first slide
            customPrevBtn.style.opacity = '0';
            customPrevBtn.style.pointerEvents = 'none';
          } else {
            // Show previous button when not on first slide
            customPrevBtn.style.opacity = '1';
            customPrevBtn.style.pointerEvents = 'auto';
          }
        }
      }
      // End - TSS-003 Customization for Product Media Gallery
    }
  );
}
